<div fxLayout="column" fxLayoutAlign="end stretch" fxFlex>
    <div class="state">
        {{'RDP_HTML5.' + state | translate}}...
    </div>
    <mat-progress-bar mode="determinate" color="accent" [value]="stateCount"></mat-progress-bar>
</div>
